var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.id !== _vm.UserId)?_c('h2',[_vm._v(_vm._s(_vm.id ? _vm.t('users::page.title.edit_user') : _vm.t('users::page.title.new_user')))]):_c('h2',[_vm._v("\n            "+_vm._s(_vm.t('dms-users::page.title.my_profile'))+"\n        ")])]),_vm._v(" "),_c('base-user-form',{attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }